/* eslint-disable react/prop-types */
import React from 'react';

import { AnimationsSettingsProvider } from '@bluefin/components';

function AnimationsSettingsContextWrapper({ children, enabled = true }) {
  const animationsSettingsContext = { enabled };

  return (
    <AnimationsSettingsProvider value={animationsSettingsContext}>
      {children}
    </AnimationsSettingsProvider>
  );
}

export default AnimationsSettingsContextWrapper;
